import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import Login from "../pages/auth/Login";
import Password from "../pages/auth/Password";
import ForgotPassword from "../pages/auth/ForgotPassword";
import VerifyOtp from "../pages/auth/VerifyOtp";
import CreateAccount from "../pages/auth/CreateAccount";
import ResetPassword from "../pages/auth/ResetPassword";
import CreateAccountScreen2 from "../pages/auth/CreateAccountScreen2";
import CreateAccountScreen3 from "../pages/auth/CreateAccountScreen3";
import LanguageSelector from "../pages/auth/LanguageSelector";
import PlanExpired from "../pages/PlanExpired";
import ProtectedRoute from "./ProtectedRoute";
import { PublicRoute } from "./PublicRoute";
import Profile from "../pages/profile/Profile";
import UserProfileEdit from "../pages/profile/UserProfileEdit";
import HelpGuide from "../pages/HelpGuide";
import ChangePassword from "../pages/ChangePassword";
import DeleteAccount from "../pages/DeleteAccount";
import StartScan from "../pages/StartScan";
import Dashboard from "../pages/Dashboard";
import ViewDetailsScreen from "../pages/scanDetails/ViewDetailsScreen";
import Documents from "../pages/documents/Documents";
import UploadDocument from "../pages/documents/UploadDocument";
import History from "../pages/History";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import Articles from "../pages/articles/Articles";
import ArticlesDetails from "../pages/articles/ArticlesDetails";
import UserScanDetails from "../pages/scanDetails/UserScanDetails";
import TermsAndConditions from "../pages/TermsAndConditions";
import AboutUs from "../pages/AboutUs";
import CreateAccountScreen4 from "../pages/auth/CreateAccountScreen4";
import ExportScanApprove from "../pages/ExportScanApprove";
import ExportDocument from "../pages/ExportDocument";
import ViewExportList from "../pages/ViewExportList";
import Notification from "../pages/Notification";
import DeleteAccountV2 from "../pages/DeleteAccount-v2";
import GuestScan from "../pages/GuestScan";
import GuestHistory from "../pages/GuestHistory";
import GuestList from "../pages/GuestList";
import SurveyForm from "../pages/survey/SurveyForm";
import RecommendedProduct from "../pages/survey/RecommendedProduct";
import ListCampaign from "../pages/campaign/ListCampaign";
import CreateCampaign from "../pages/campaign/CreateCampaign";
import DetailsCampaign from "../pages/campaign/DetailsCampaign";
import ProductDetails from "../pages/survey/ProductDetails";
import CreateAccountScreen1 from "../pages/auth/SignUp/CreateAccountScreen";
import CreateAccount2 from "../pages/auth/SignUp/CreateAccount2";
import CreateAccount3 from "../pages/auth/SignUp/CreateAccount3";
import CreateAccount4 from "../pages/auth/SignUp/CreateAccount4";
import CreateAccount5 from "../pages/auth/SignUp/CreateAccount5";
import QrScanner from "../pages/QrScanner";
import ViewQuestions from "../pages/profile/ViewQuestions";
import FourLifeLogin from "../pages/auth/FourLifeLogin";
import AskAI from "../pages/AskAI";
import Dashboard2 from "../pages/Dashboard2";
import ShowAllResult from "../pages/ShowAllResult";
import ShowAllResult2 from "../pages/ShowAllResult2";
import FourLifeScanHistory from "../pages/scanDetails/FourLifeScanHistory";

const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <LanguageSelector />
            </PublicRoute>
          }
        />
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/login-v2"
          element={
            <PublicRoute>
              <FourLifeLogin />
            </PublicRoute>
          }
        />
        <Route
          path="/password"
          element={
            <PublicRoute>
              <Password />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/verify-otp"
          element={
            <PublicRoute>
              <VerifyOtp />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account"
          element={
            <PublicRoute>
              <CreateAccount />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account-v2"
          element={
            <PublicRoute>
              <CreateAccountScreen2 />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account-v3"
          element={
            <PublicRoute>
              <CreateAccountScreen3 />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account-v4"
          element={
            <PublicRoute>
              <CreateAccountScreen4 />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/qr-scanner"
          element={
            <PublicRoute>
              <QrScanner />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard2"
          element={
            <ProtectedRoute>
              <Dashboard2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/show-all-result"
          element={
            <ProtectedRoute>
              <ShowAllResult />
            </ProtectedRoute>
          }
        />
        <Route
          path="/show-all-result-2"
          element={
            <ProtectedRoute>
              <ShowAllResult2 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile-update"
          element={
            <ProtectedRoute>
              <UserProfileEdit />
            </ProtectedRoute>
          }
        />
        <Route
          path="/language-selection"
          element={
            <ProtectedRoute>
              <LanguageSelector />
            </ProtectedRoute>
          }
        />
        <Route
          path="/deleteAcc-one"
          element={
            <ProtectedRoute>
              <DeleteAccount />
            </ProtectedRoute>
          }
        />
        <Route
          path="/delete-account"
          element={
            <PublicRoute>
              <DeleteAccountV2 />
            </PublicRoute>
          }
        />
        <Route
          path="/help-guide"
          element={
            <ProtectedRoute>
              <HelpGuide />
            </ProtectedRoute>
          }
        />
        <Route
          path="/change-password"
          element={
            <ProtectedRoute>
              <ChangePassword />
            </ProtectedRoute>
          }
        />

        <Route
          path="/start-scan"
          element={
            <ProtectedRoute>
              <StartScan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-more-details"
          element={
            <ProtectedRoute>
              <ViewDetailsScreen />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documents"
          element={
            <ProtectedRoute>
              <Documents />
            </ProtectedRoute>
          }
        />

        <Route
          path="/upload-document"
          element={
            <ProtectedRoute>
              <UploadDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path="/history"
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        />
        <Route />
        <Route
          path="/privacy-policy"
          element={
            <ProtectedRoute>
              <PrivacyPolicy />
            </ProtectedRoute>
          }
        />
        <Route />
        <Route
          path="/terms-condition"
          element={
            <ProtectedRoute>
              <TermsAndConditions />
            </ProtectedRoute>
          }
        />
        <Route
          path="/articles"
          element={
            <ProtectedRoute>
              <Articles />
            </ProtectedRoute>
          }
        />
        <Route
          path="/articles/:id"
          element={
            <ProtectedRoute>
              <ArticlesDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-scan-details"
          element={
            <ProtectedRoute>
              <UserScanDetails />
            </ProtectedRoute>
          }
        />
        <Route
          path="/user-scan-details-four-life"
          element={
            <ProtectedRoute>
              <FourLifeScanHistory />
            </ProtectedRoute>
          }
        />

        <Route
          path="/about-us"
          element={
            <ProtectedRoute>
              <AboutUs />
            </ProtectedRoute>
          }
        />
        <Route
          path="/privacy-consent"
          element={
            <ProtectedRoute>
              <ExportScanApprove />
            </ProtectedRoute>
          }
        />

        <Route
          path="/export-document"
          element={
            <ProtectedRoute>
              <ExportDocument />
            </ProtectedRoute>
          }
        />
        <Route
          path="/view-export"
          element={
            <ProtectedRoute>
              <ViewExportList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/notification"
          element={
            <ProtectedRoute>
              <Notification />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guest-scan"
          element={
            <ProtectedRoute>
              <GuestScan />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guest-history"
          element={
            <ProtectedRoute>
              <GuestHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/guest-list"
          element={
            <ProtectedRoute>
              <GuestList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/survey-form"
          element={
            // <ProtectedRoute>
            <SurveyForm />
            // </ProtectedRoute>
          }
        />
        <Route
          path="/recommended-product"
          element={
            <ProtectedRoute>
              <RecommendedProduct />
            </ProtectedRoute>
          }
        />

        <Route
          path="/product-details"
          element={
            <ProtectedRoute>
              <ProductDetails />
            </ProtectedRoute>
          }
        />

        <Route
          path="/campaign-list"
          element={
            <ProtectedRoute>
              <ListCampaign />
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaign-create"
          element={
            <ProtectedRoute>
              <CreateCampaign />
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaign-details"
          element={
            <ProtectedRoute>
              <DetailsCampaign />
            </ProtectedRoute>
          }
        />

        <Route
          path="/view-questions"
          element={
            <ProtectedRoute>
              <ViewQuestions />
            </ProtectedRoute>
          }
        />

        <Route
          path="/plan-expired"
          element={
            <ProtectedRoute>
              <PlanExpired />
            </ProtectedRoute>
          }
        />

        {/* SignUp */}

        <Route
          path="/create-account-1"
          element={
            <PublicRoute>
              <CreateAccountScreen1 />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account-2"
          element={
            <PublicRoute>
              <CreateAccount2 />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account-3"
          element={
            <PublicRoute>
              <CreateAccount3 />
            </PublicRoute>
          }
        />

        <Route
          path="/create-account-5"
          element={
            <PublicRoute>
              <CreateAccount5 />
            </PublicRoute>
          }
        />
        <Route
          path="/ask-ai"
          element={
            <ProtectedRoute>
              <AskAI />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
};

export default AppRouter;
